module.exports = __webpack_public_path__ + "img/img_covertack_reflection.e7efb4f9.png";